import {
  getAppConfig
} from "src/_helpers"
export const CurrencyText = (props) => {
  var unit = getAppConfig('CURRENCY_UNIT')
  return (
    <>
      <b>{props.value ? (Number(props.value)).toLocaleString() : 0} {unit}</b>
    </>
  )
}